// Zambian provinces, cities, towns, and universities for location picker.
// Mirrored from mobile/src/core/data/zambianLocations.ts — keep in sync.

export const ZAMBIAN_LOCATIONS = {
  provinces: [
    {
      name: "Lusaka",
      cities: [
        { name: "Lusaka", towns: ["Chelstone", "Kabwata", "Kabulonga", "Kalingalinga", "Matero", "Chilenje", "Woodlands", "Roma", "Ibex Hill", "Avondale", "Rhodes Park", "Northmead", "Emmasdale", "Garden", "PHI", "Chainda", "Chawama", "George", "John Laing", "Kamwala", "Libala", "Longacres", "Makeni", "Munali", "Olympia", "Showgrounds"] },
        { name: "Kafue", towns: ["Kafue Town", "Nangongwe"] },
        { name: "Chongwe", towns: ["Chongwe Town"] },
      ],
    },
    {
      name: "Copperbelt",
      cities: [
        { name: "Kitwe", towns: ["Riverside", "Parklands", "Nkana East", "Nkana West", "Wusakile", "Chimwemwe", "Mindolo", "Kwacha", "Bulangililo", "Kamitondo"] },
        { name: "Ndola", towns: ["Kansenshi", "Itawa", "Northrise", "Chipulukusu", "Lubuto", "Masala", "Hillcrest", "Pamodzi"] },
        { name: "Mufulira", towns: ["Mufulira Town", "Kankoyo"] },
        { name: "Luanshya", towns: ["Roan", "Mpatamatu", "Section 25"] },
        { name: "Chingola", towns: ["Chingola Town", "Nchanga"] },
      ],
    },
    {
      name: "Southern",
      cities: [
        { name: "Livingstone", towns: ["Livingstone Town", "Dambwa", "Maramba"] },
        { name: "Choma", towns: ["Choma Town"] },
        { name: "Mazabuka", towns: ["Mazabuka Town"] },
      ],
    },
    {
      name: "Central",
      cities: [
        { name: "Kabwe", towns: ["Kabwe Town", "Highridge", "Natuseko"] },
        { name: "Kapiri Mposhi", towns: ["Kapiri Mposhi Town"] },
        { name: "Serenje", towns: ["Serenje Town"] },
      ],
    },
    {
      name: "Eastern",
      cities: [
        { name: "Chipata", towns: ["Chipata Town"] },
        { name: "Petauke", towns: ["Petauke Town"] },
        { name: "Katete", towns: ["Katete Town"] },
      ],
    },
    {
      name: "Northern",
      cities: [
        { name: "Kasama", towns: ["Kasama Town"] },
        { name: "Mpika", towns: ["Mpika Town"] },
        { name: "Mbala", towns: ["Mbala Town"] },
      ],
    },
    {
      name: "Luapula",
      cities: [
        { name: "Mansa", towns: ["Mansa Town"] },
        { name: "Nchelenge", towns: ["Nchelenge Town"] },
        { name: "Samfya", towns: ["Samfya Town"] },
      ],
    },
    {
      name: "Northwestern",
      cities: [
        { name: "Solwezi", towns: ["Solwezi Town"] },
        { name: "Kasempa", towns: ["Kasempa Town"] },
        { name: "Mwinilunga", towns: ["Mwinilunga Town"] },
      ],
    },
    {
      name: "Western",
      cities: [
        { name: "Mongu", towns: ["Mongu Town"] },
        { name: "Senanga", towns: ["Senanga Town"] },
        { name: "Kaoma", towns: ["Kaoma Town"] },
      ],
    },
    {
      name: "Muchinga",
      cities: [
        { name: "Chinsali", towns: ["Chinsali Town"] },
        { name: "Isoka", towns: ["Isoka Town"] },
      ],
    },
  ],
  universities: [
    "UNZA - University of Zambia",
    "CBU - Copperbelt University",
    "Mulungushi University",
    "ZCAS University",
    "Cavendish University",
    "DMI - St. Eugene University",
    "Zambian Open University",
    "Levy Mwanawasa Medical University",
    "NORTEC",
    "Evelyn Hone College",
    "Lusaka Apex Medical University",
    "University of Lusaka",
    "Texila American University",
    "LIUTEBM University",
    "Rusangu University",
    "Copperstone University",
  ],
};

export function getAllLocations() {
  const locs = [];
  ZAMBIAN_LOCATIONS.provinces.forEach((p) => {
    p.cities.forEach((c) => {
      c.towns.forEach((t) => {
        locs.push({ display: `${t}, ${c.name}, ${p.name}`, town: t, city: c.name, province: p.name, type: "town" });
      });
    });
  });
  ZAMBIAN_LOCATIONS.universities.forEach((u) => {
    locs.push({ display: u, town: null, city: null, province: null, type: "university" });
  });
  return locs;
}
